import { render, staticRenderFns } from "./OrderSelected.vue?vue&type=template&id=d689641c&"
import script from "./OrderSelected.vue?vue&type=script&lang=js&"
export * from "./OrderSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports